import { render, staticRenderFns } from "./CreateAppointments.vue?vue&type=template&id=113dd956&scoped=true&"
import script from "./CreateAppointments.vue?vue&type=script&lang=js&"
export * from "./CreateAppointments.vue?vue&type=script&lang=js&"
import style0 from "./CreateAppointments.vue?vue&type=style&index=0&id=113dd956&prod&lang=css&"
import style1 from "./CreateAppointments.vue?vue&type=style&index=1&id=113dd956&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113dd956",
  null
  
)

export default component.exports